import React from 'react'
import PropTypes from 'prop-types'
import PlanPriceButton from 'components/Payment/PlanPriceButton'
import { apiSandboxData } from './plansUtil.js'
import FeaturesList from './FeaturesList.jsx'

const PlanSelector = (props) => {
  const isApi = props?.showApi || false
  const plans = isApi ? [apiSandboxData, ...props.plans] : props.plans
  const currentApiPlan = props.currentApiPlan || null
  const showTrial = !currentApiPlan || currentApiPlan === 'Sandbox'
  const expiredTrial = props.sandboxUser && currentApiPlan !== 'Sandbox'

  const btnElements = _.map(plans, (plan) => {
    return (
      <PlanPriceButton
        key={plan.plan}
        {...plan}
        onClickPlan={props.onClickPlan}
        currentApiPlan={currentApiPlan}
        isCurrent={
          props.currentPlan === plan.plan || currentApiPlan === plan.name
        }
        isSelected={props.selectedPlan === plan.plan}
        isApi={isApi}
        offer={props.offer}
        registeredUser={props.registeredUser}
        hasPaidAccount={props.hasPaidAccount}
        expiredTrial={expiredTrial}
      />
    )
  })

  const handlePlanClick = (name) => {
    const apiTiersEle = document.getElementById('api-tiers')
    const plansEle = document.getElementById('plan-options')
    const scrollTo = apiTiersEle || plansEle
    debug('handlePlanClick name: ', name)
    if(name === 'San') { return }
    if(isApi && currentApiPlan && currentApiPlan.slice(0, 3) !== name) {
      // api user is switching plans, don't scroll
      return
    }
    if(scrollTo) {
      scrollTo.scrollIntoView({
        behavior: 'smooth',
        block:    'start',
      })
    }

    const planBtn = document.querySelector(`div.${name} a`)
    planBtn.click()
  }

  return (
    <div className={`plans${isApi ? ' api-plans' : ''}`}>
      {isApi && (
        <h2 className="h2 bold centered margin-btm-lg">
          Self-Serve Parcel Data API Plans That Scale
        </h2>
      )}
      <div className={`plans-in${isApi ? ' api-plans-cards' : ''}`}>
        {_.map(plans, (plan, i) => {
          if(!showTrial && plan?.name === 'Sandbox') {
            return null // don't show sandbox if user has a paid api account
          }
          const isCurrent =
            props.currentPlan === plan?.plan || currentApiPlan === plan?.name

          return (
            <div
              className={
                `plan grow plan-${plan.name
                  .replace(/ .*/, '')
                  .toLowerCase()} margin-btm-md` +
                (isCurrent ? ' not-allowed' : '')
              }
              key={i + 1}
              onClick={() =>
                isCurrent ? undefined : handlePlanClick(plan.name.slice(0, 3))
              }
            >
              <div className="info-text">
                <h3
                  className={`margin-top-none margin-btm-md ${
                    isApi ? '' : 'centered'
                  }`}
                >
                  {plan.display_name ? plan.display_name : plan.name}
                </h3>
                <h4
                  className={`margin-top-none margin-btm-md ${
                    isApi ? '' : 'centered'
                  }`}
                >
                  {plan.subtitle ? plan.subtitle : ''}
                </h4>
                {_.map(plan.description, (description, j) => (
                  <p
                    className="desc"
                    key={j + 1}
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></p>
                ))}
              </div>

              <div className="info mobile-only">{btnElements[i]}</div>
              <div className="info nomobile">
                <div className={plan.name.slice(0, 3)} key={i}>
                  {btnElements[i]}
                </div>
              </div>
              {isApi && (
                <FeaturesList plan={plan}/>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

PlanSelector.propTypes = {
  plans:                 PropTypes.array.isRequired,
  onClickPlan:           PropTypes.func.isRequired,
  onClickCycle:          PropTypes.func.isRequired,
  selectedPlan:          PropTypes.string,
  currentPlan:           PropTypes.string,
  currentCycle:          PropTypes.string,
  showApi:               PropTypes.bool,
  currentApiPlan:        PropTypes.object,
  sandboxUser:           PropTypes.bool,
  offer:                 PropTypes.object,
  registeredUser:        PropTypes.object,
  hasPaidAccount:        PropTypes.bool,
}

export default PlanSelector
